import React from 'react';
import { AssetType } from "../../../../../utils/storage";
import MediaRenderer from "../../../../core/components/MediaRenderer";
import { CAROUSEL_ITEM_ACTIVATION_DELAY } from "../PosterChapter.constants";

interface SectionMediaProps {
    media: AssetType | null
    style?: React.CSSProperties,
    toApplyInternalEffect?: boolean,
    delayInternalEffect?: number,
}

function Media(props: SectionMediaProps) {
    const {
        media,
        style = {},
        toApplyInternalEffect = true,
        delayInternalEffect = CAROUSEL_ITEM_ACTIVATION_DELAY,
    } = props;

    if (!media) {
        return null;
    }

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                ...style,
            }}
        >
            <MediaRenderer
                media={media}
                cover='fill'
                toApplyInternalEffect={toApplyInternalEffect}
                delayInternalEffect={delayInternalEffect}
            />
        </div>
    )
}

export default Media;
